<section id="adobe-services" class="adobe-services-section">
  <div class="container">
    <h2 class="section-title text-center" data-animation="fade-in-up">The Adobe Products Behind Our Transformation</h2>
    <p class="section-subtitle text-center mb-5" data-animation="fade-in-up" data-animation-delay="1">
      Adobe apps that powered our transformation and continue to drive innovation.
    </p>
    
    <!-- Horizontal continuously scrolling banner -->
    <div class="adobe-services-slider" data-animation="fade-in-up" data-animation-delay="1">
      <div class="slider-container">
        <div class="slider-track" #sliderTrack>
          <!-- Original items -->
          <div class="adobe-service-slide" *ngFor="let service of adobeServices; let i = index">
            <div class="adobe-service-card" [style.border-color]="service.color">
              <div class="service-icon" [style.background-color]="service.color">
                <img [src]="service.logoPath" [alt]="service.name + ' logo'" class="service-logo">
              </div>
              <div class="service-name">
                {{service.name}}
              </div>
              <div class="service-hover-overlay" [style.background-color]="service.color">
                <div class="service-hover-content">
                  <img [src]="service.logoPath" [alt]="service.name + ' logo'" class="service-logo-hover mb-2">
                  <div>{{service.name}}</div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Duplicate items for infinite scrolling effect -->
          <div class="adobe-service-slide duplicate-card" *ngFor="let service of adobeServices; let i = index">
            <div class="adobe-service-card" [style.border-color]="service.color">
              <div class="service-icon" [style.background-color]="service.color">
                <img [src]="service.logoPath" [alt]="service.name + ' logo'" class="service-logo">
              </div>
              <div class="service-name">
                {{service.name}}
              </div>
              <div class="service-hover-overlay" [style.background-color]="service.color">
                <div class="service-hover-content">
                  <img [src]="service.logoPath" [alt]="service.name + ' logo'" class="service-logo-hover mb-2">
                  <div>{{service.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>